// Bumped whenever Terms or Privacy meaningfully change.
// Must match LAST_UPDATED in src/pages/Legal.jsx.
// Users whose `legal_acknowledged_version` doesn't equal this value will see
// the consent banner on next app load.
export const LEGAL_VERSION = "2026-06-09";
